import BaseRegulation from "../base_regulation";
import TempAccountMessageRegulationHelper from "../../helpers/temp_account_message_helper";
import { TEMP_ACCOUNT_STATUS } from "../../regulation_const";

export default class PortugalRegulation extends BaseRegulation {

	static CLASS = 'PortugalRegulation';

	init(params) {
		super.init(params);
		this._tempAccountMessageHelper = params.tempAccountMessageHelper || TempAccountMessageRegulationHelper.create({
			serviceFactory: this.serviceFactory
		});
	}

	private _tempAccountMessageHelper: TempAccountMessageRegulationHelper;

	showTempAccountMessage(closeFunc) {
        this._tempAccountMessageHelper.showTempAccountMessage({
            closeFunc: closeFunc,
            paramsFunc: this._getTempAccountParams.bind(this),
        });
	}
	
	private _getTempAccountParams() {
        const accountData = this.serviceFactory.userService().getAccountData();
		let daysLeft = accountData.DaysToUploadDocument;
		let status = TEMP_ACCOUNT_STATUS.APPROVED;

		if (daysLeft >= 0 && (accountData.RegulationStatusId === 1 || accountData.RegulationStatusId === 2)) {
			status = TEMP_ACCOUNT_STATUS.DOCUMENTS_NOT_RECEIVED;
		}

        return {
			messageKey: 'pt_temp_account_message',
			footerMessageKey: 'pt_temp_account_footer_message',
			titleKey: 'temp_account_title',
			btnNameKey: 'temp_account_upload_btn',
			daysLeft: daysLeft,
			status: status,
		};
    }

	showSessionBalanceInAboutBox() {
		return true;
	}
}